import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  MenuItem,
  Select,
  InputLabel,Divider,
  FormControl,
  useTheme,
} from '@mui/material';
import BusinessVerticalStatsWidget from "./BusinessVerticalStatsWidget";
import FilterHeader from "../../components/FilterHeader";
import CheckInStatsChart from "./CheckInStatsChart";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CheckInStatsByHour from "./CheckInStatsByHour";
import CheckInBarChartLatestDate from "./CheckInBarChartLatestDate";
import dayjs from 'dayjs';



 const Dashboard = () => {

    const [asOnDate, setAsOnDate] = useState(dayjs());
   const [filters, setFilters] = useState({
      VerticalDescriptions: "All",
      ProjectDescriptions: "All",
      Locations: "All",
    });


  return (
    <div>  
      <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            {/* Left: Title */}
            <Typography variant="h2" sx={{ minWidth: 180 }}>
              Dashboard
            </Typography>

            {/* Right: Filters + Export */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "flex-end",   
                minWidth: "60%",               
              }}
            >
              <FilterHeader filters={filters} setFilters={setFilters} showProject={false}  showLocation={false}/>
                <DatePicker
                  label="End Date"
                  value={asOnDate}
                  format="DD-MMM-YYYY"
                  onChange={(newVal) => setAsOnDate(newVal)}
                  slotProps={{ textField: { size: 'small' } }}
                />
            </Box>
      </Box> 
      
    <Divider sx={{ m: 1}} /> 
       <Grid container spacing={2} sx={{ padding: 0 }}> 
        <Grid item size={{sm: 12, md:6}}>
             <Box sx={{ marginBottom: 1 }}>
              <BusinessVerticalStatsWidget
                selectedVertical={filters.VerticalDescriptions} // from dropdown
                selectedDate={asOnDate.format('YYYY-MM-DD')} // from date picker
              />
            </Box>
        </Grid>
        <Grid item size={{sm: 12, md:6}}>
             <Box sx={{ marginBottom: 1 }}>
              <CheckInStatsChart
                selectedVertical={filters.VerticalDescriptions} // from dropdown
                selectedDate={asOnDate.format('YYYY-MM-DD')} // from date picker
              />
            </Box>
        </Grid>
      </Grid> 

  <Grid container spacing={2} sx={{ mt: 1 }}> 
        <Grid item size={{xs: 12, md:6}}>
             <Box sx={{ marginBottom: 1 }}>
              <CheckInStatsByHour
                selectedVertical={filters.VerticalDescriptions} // from dropdown
                selectedDate={asOnDate.format('YYYY-MM-DD')} // from date picker
              />
            </Box>
        </Grid>

          <Grid item size={{xs: 12, md:6}}>
             <Box sx={{ marginBottom: 1 }}>
              <CheckInBarChartLatestDate
                selectedVertical={filters.VerticalDescriptions} // from dropdown
                selectedDate={asOnDate.format('YYYY-MM-DD')} // from date picker
              />
            </Box>
        </Grid>
         
      </Grid> 

      
    </div>
  );
}
export default Dashboard;

